export default __webpack_public_path__ + "static/media/logo-comp.f26ac7a3.png";